<template><section><h2>Basic Pie Chart 基本饼图</h2>
<block-demo tip="" source="const data = [
  {
    year: &#39;2010&#39;,
    population: 74
  },
  {
    year: &#39;2011&#39;,
    population: 62
  },
  {
    year: &#39;2012&#39;,
    population: 54
  },
  {
    year: &#39;2013&#39;,
    population: 27
  },
  {
    year: &#39;2014&#39;,
    population: 41
  },
  {
    year: &#39;2015&#39;,
    population: 91
  },
  {
    year: &#39;2016&#39;,
    population: 74
  },
  {
    year: &#39;2017&#39;,
    population: 62
  },
  {
    year: &#39;2018&#39;,
    population: 54
  },
  {
    year: &#39;2019&#39;,
    population: 27
  },
  {
    year: &#39;2020&#39;,
    population: 41
  },
  {
    year: &#39;2021&#39;,
    population: 74
  },
  {
    year: &#39;2022&#39;,
    population: 62
  },
  {
    year: &#39;2023&#39;,
    population: 54
  },
  {
    year: &#39;2024&#39;,
    population: 27
  },
  {
    year: &#39;2025&#39;,
    population: 41
  },
  {
    year: &#39;2026&#39;,
    population: 74
  },
  {
    year: &#39;2027&#39;,
    population: 62
  },
  {
    year: &#39;2028&#39;,
    population: 54
  },
  {
    year: &#39;2029&#39;,
    population: 27
  },
  {
    year: &#39;2030&#39;,
    population: 41
  }
]

const { Chart, Pie, Legend, Tooltip } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;
})

chart.source(data, {
  row: &#39;year&#39;,
  value: &#39;population&#39;,
  text: &#39;year&#39;
})

const pie = new Pie({
  radius: 0.7,
  animation: {
    duration: 700,
    easing: &#39;bounceOut&#39;
    // 缓动类型
    //[&quot;linear&quot;, &quot;quadIn&quot;, &quot;quadOut&quot;, &quot;quadInOut&quot;, &quot;cubicIn&quot;, &quot;cubicOut&quot;, &quot;cubicInOut&quot;, &quot;quarticIn&quot;, &quot;quarticOut&quot;, &quot;quarticInOut&quot;, &quot;quinticIn&quot;, &quot;quinticOut&quot;, &quot;quinticInOut&quot;, &quot;sinusoidalIn&quot;, &quot;sinusoidalOut&quot;, &quot;sinusoidalInOut&quot;, &quot;exponentialIn&quot;, &quot;exponentialOut&quot;, &quot;exponentialInOut&quot;, &quot;circularIn&quot;, &quot;circularOut&quot;, &quot;circularInOut&quot;, &quot;elasticIn&quot;, &quot;elasticOut&quot;, &quot;elasticInOut&quot;, &quot;backIn&quot;, &quot;backOut&quot;, &quot;backInOut&quot;, &quot;bounceIn&quot;, &quot;bounceOut&quot;, &quot;bounceInOut&quot;,]
  }
})

const legend = new Legend({ orient: &#39;vertical&#39;, align: [&#39;right&#39;, &#39;center&#39;] })
const toolTip = new Tooltip()

chart.append([pie, legend, toolTip])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2010'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">74</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2011'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">62</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2012'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">54</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2013'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">27</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2014'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">41</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2015'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">91</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2016'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">74</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2017'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">62</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2018'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">54</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2019'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">27</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2020'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">41</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2021'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">74</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2022'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">62</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2023'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">54</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2024'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">27</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2025'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">41</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2026'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">74</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2027'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">62</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2028'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">54</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2029'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">27</span>
  },
  {
    <span class="hljs-attr">year</span>: <span class="hljs-string">'2030'</span>,
    <span class="hljs-attr">population</span>: <span class="hljs-number">41</span>
  }
]

<span class="hljs-keyword">const</span> { Chart, Pie, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'year'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'population'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'year'</span>
})

<span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie({
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.7</span>,
  <span class="hljs-attr">animation</span>: {
    <span class="hljs-attr">duration</span>: <span class="hljs-number">700</span>,
    <span class="hljs-attr">easing</span>: <span class="hljs-string">'bounceOut'</span>
    <span class="hljs-comment">// 缓动类型</span>
    <span class="hljs-comment">//["linear", "quadIn", "quadOut", "quadInOut", "cubicIn", "cubicOut", "cubicInOut", "quarticIn", "quarticOut", "quarticInOut", "quinticIn", "quinticOut", "quinticInOut", "sinusoidalIn", "sinusoidalOut", "sinusoidalInOut", "exponentialIn", "exponentialOut", "exponentialInOut", "circularIn", "circularOut", "circularInOut", "elasticIn", "elasticOut", "elasticInOut", "backIn", "backOut", "backInOut", "bounceIn", "bounceOut", "bounceInOut",]</span>
  }
})

<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'right'</span>, <span class="hljs-string">'center'</span>] })
<span class="hljs-keyword">const</span> toolTip = <span class="hljs-keyword">new</span> Tooltip()

chart.append([pie, legend, toolTip])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>